import { type Components, type Theme } from "@mui/material/styles";

export const dialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    paper: () => ({
      maxWidth: "500px",
      padding: "48px",
      borderRadius: "12px",
    }),
  },
};
